import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
// core components
import Header from "dashboard/project-management/components/Headers/Header";
import Select from "react-select";
import { api } from "../../../../api";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Cookies from 'js-cookie';

const Editproject1 = () => {
  const { id } = useParams();

  const [modalOpen, setModalOpen] = useState(false);
  const [showAddClientModal, setShowAddClientModal] = useState(false); // New state for Add Project modal
  const [clientForm, setClientForm] = useState({});

  const toggleModal = () => setModalOpen((prevState) => !prevState);
  const toggleAddClientModal = () =>
    setShowAddClientModal((prevState) => !prevState); // Function to toggle Add Project modal

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");

  const handleManagerSelectChange = (selectedOption) => {
    setSelectedManager(selectedOption);
  };

  const handleLocationSelectChange = (selectedOption) => {
    setSelectedLocation(selectedOption);
  };

  const emp_id = Cookies.get('token');

  // const [members, setmembers] = useState();
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await api.get("empGMdetails.php");

  //       // Extract only two variables and format them
  //       const formattedData = response.data.map((item) => ({
  //         value: item.emp_id, // Assuming employee id is stored in 'id'
  //         label: item.emp_name, // Assuming employee name is stored in 'name'
  //       })); // Take only the first two records

  //       setmembers(formattedData);
  //       console.log(response.data);
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };
  //   fetchData();
  // }, []);

  const [updateValue, setupdateValues] = useState({
    p_id: id,
    p_name: "",
    p_status: "pending",
    p_budget: "",
    site_manager: '',
    start_date: "",
    end_date: "",
    p_location: "",
    p_description: "",
    departments: '',
    BOQ: null,
    BOM: null,
    files: '',
    project_manager_id: '',
    gm_id: emp_id,
    client_id: ''
  });

  const [allfiles, setallfiles] = useState({
    BOQ: '',
    BOM: '',
    files: '',
  });

  const [selecteddepartment, setselecteddepartment] = useState([]);

  // Add these states at the top
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedProjectManager, setSelectedProjectManager] = useState(null);
  const [roleNames, setRoleNames] = useState({
    projectManager: 'Project Manager',
    generalManager: 'General Manager',
    siteManager: 'Site Manager'
  });

  // Function to fetch role names for the company
  const fetchRoleNames = async (company_id) => {
    try {
      const response = await api.get(`roleConfig.php?company_id=${company_id}`);
      if (response.data && response.data.status === 'success') {
        const roles = response.data.data;
        const roleMap = {};
        
        console.log("Fetched roles for company:", roles);
        
        roles.forEach(role => {
          if (role.role_name) {
            // Map based on dashboard path to identify role types
            if (role.dashboard_path.includes('project-management')) {
              // For project management roles, take any role name from this dashboard path
              // This works like General Manager - picks up any custom name
              roleMap.projectManager = role.role_name;
            } else if (role.dashboard_path.includes('general-management')) {
              roleMap.generalManager = role.role_name;
            } else if (role.dashboard_path.includes('site-management')) {
              // For site management roles, take any role name from this dashboard path
              // This works like General Manager - picks up any custom name
              roleMap.siteManager = role.role_name;
            }
          }
        });
        
        console.log("Mapped role names:", roleMap);
        
        setRoleNames(prev => ({
          ...prev,
          ...roleMap
        }));
      }
    } catch (error) {
      console.error("Error fetching role names:", error);
    }
  };

  // Move fetchProject outside useEffect so it can be called after submit
  const fetchProject = async () => {
    try {
      const company_id = Cookies.get('company_id');
      
      // Fetch project data and role names in parallel
      const [res] = await Promise.all([
        api.get(`viewProjectByID.php?p_id=${id}&company_id=${company_id}`),
        fetchRoleNames(company_id)
      ]);
      
      console.log("API response:", res.data); // Debug log
      if (res.data && !res.data.message) {
        const data = res.data;
        setupdateValues(prev => ({
          ...prev,
          p_name: data.p_name || "",
          p_status: data.p_status || "to-do",
          p_budget: data.p_budget || "",
          site_manager: data.site_manager || "",
          start_date: data.start_date || "",
          end_date: data.end_date || "",
          p_location: data.p_location || "",
          p_description: data.p_description || "",
          departments: Array.isArray(data.departments) ? data.departments : (data.departments ? data.departments.split(',') : []),
          project_manager_id: data.project_manager_id || "",
          gm_id: data.gm_id || "",
          client_id: data.client_id || "",
          BOQ: data.BOQ || "",
          BOM: data.BOM || "",
          files: Array.isArray(data.files)
            ? data.files
            : (typeof data.files === "string" && data.files.length > 0
                ? data.files.split(",").map(f => f.trim()).filter(f => f)
                : []),
        }));
        setallfiles({
          BOQ: data.BOQ || "",
          BOM: data.BOM || "",
          files: data.files || "",
        });
        // Set selected values for selects
        setSelectedClient(data.client_id || "");
        setSelectedProjectManager(data.project_manager_id || "");
        setselecteddepartment(
          Array.isArray(data.departments) && Array.isArray(data.department_names)
            ? data.departments.map((id, idx) => ({
                value: id,
                label: data.department_names[idx] || id
              }))
            : []
        );
      } else {
        // Handle no data found
        setupdateValues(prev => ({
          ...prev,
          p_name: "",
          p_status: "to-do",
          p_budget: "",
          site_manager: "",
          start_date: "",
          end_date: "",
          p_location: "",
          p_description: "",
          departments: "",
          project_manager_id: "",
          gm_id: "",
          client_id: "",
          BOQ: "",
          BOM: "",
          files: [],
        }));
        setallfiles({
          BOQ: "",
          BOM: "",
          files: "",
        });
      }
    } catch (err) {
      // Handle error
      console.error("Error fetching project:", err);
    }
  };

  useEffect(() => {
    fetchProject();
  }, [id]);
  

  const [project, setProject] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const emp_id = Cookies.get('emp_id');
        const response = await api.get(`viewProjectDetails.php?p_m_id=${emp_id}&company_id=${company_id}`);
        setProject(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);


  const formDataToSend = new FormData();
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const company_id = Cookies.get('company_id');
    const emp_id = Cookies.get('emp_id');
    formDataToSend.append('company_id', company_id);
    formDataToSend.append('emp_id', emp_id);

    formDataToSend.append('p_id', updateValue.p_id);
    formDataToSend.append('p_name', updateValue.p_name);
    formDataToSend.append('p_status', updateValue.p_status || "to-do");
    formDataToSend.append('p_budget', updateValue.p_budget);
    formDataToSend.append('p_site_manager', [updateValue.site_manager]);
    formDataToSend.append('start_date', updateValue.start_date);
    formDataToSend.append('end_date', updateValue.end_date);
    formDataToSend.append('p_location', updateValue.p_location);
    formDataToSend.append('p_description', updateValue.p_description);
    formDataToSend.append('departments[]', updateValue.departments);
    formDataToSend.append('BOQ', updateValue.BOQ);
    formDataToSend.append('BOM', updateValue.BOM);
    if (updateValue.files && updateValue.files.length > 0) {
      for (let i = 0; i < updateValue.files.length; i++) {
        formDataToSend.append("image[]", updateValue.files[i]);
      }
    } else {
      formDataToSend.append("image[]", null);
    }
    formDataToSend.append('project_manager_id', updateValue.project_manager_id);
    formDataToSend.append('gm_id', updateValue.gm_id);
    formDataToSend.append('client_id', updateValue.client_id);
    formDataToSend.append('old_boq', allfiles.BOQ);
    formDataToSend.append('old_bom', allfiles.BOM);
    formDataToSend.append('old_image', allfiles.files);

    console.log(updateValue);

    try {
      const response = await api.post("editProject.php", formDataToSend);
      console.log("Data sent successfully:", response.data);

      setallfiles({
        BOQ: response.data.BOQ || allfiles.BOQ,
        BOM: response.data.BOM || allfiles.BOM,
        files: response.data.files || allfiles.files,
      });

      alert("Project updated successfully!");
      fetchProject(); // Re-fetch the project data to update the form with the latest values
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setupdateValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    console.log(updateValue);
  };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   formDataToSend.append('files', file);
  // };

  const [selectedSiteManagers, setSelectedSiteManagers] = useState();

  const [selectedprojectmanager, setselectedprojectmanager] = useState({
    value: "",
    label: ""
  });


  const fetchDepartData = async () => {
    try {
     if (updateValue.departments != null && updateValue.departments.length > 0) {
    const departmentsParam = Array.isArray(updateValue.departments)
        ? updateValue.departments.join(',')
        : updateValue.departments;
    console.log(`Fetching departments with IDs: ${departmentsParam}`);
    const company_id = Cookies.get('company_id');
    if (!company_id) {
      throw new Error('Missing company_id in cookies');
    }
    const response = await api.get(`empSiteManDetails.php?departments=${departmentsParam}&company_id=${company_id}`);

        if (Array.isArray(response.data) && response.data.length > 0) {
          const formattedData = response.data.map((item) => ({
            value: item.d_id, // Assuming department id is stored in 'd_id'
            label: item.dept_name, // Assuming department name is stored in 'dept_name'
          }));
          setselecteddepartment(formattedData);
        } else {
          console.log("No data received or empty array");
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const runFetchDepartDataTwice = async () => {
    // await fetchDepartData();
    setTimeout(async () => {
      await fetchDepartData();
    }, 2);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        if (updateValue.site_manager != null) {
          const response = await api.get(`empSiteManDetails.php?site_manager=${updateValue.site_manager}&company_id=${company_id}`);

          if (Array.isArray(response.data) && response.data.length > 0) {
            const formattedData = response.data.map((item) => ({
              value: item.emp_id, // Assuming employee id is stored in 'emp_id'
              label: item.emp_name, // Assuming employee name is stored in 'emp_name'
            }));
            setSelectedSiteManagers(formattedData);
          } else {
            console.log("No data received or empty array");
          }
        }
        if (updateValue.project_manager_id != null) {
          const response = await api.get(`empSiteManDetails.php?project_manager_id=${updateValue.project_manager_id}&company_id=${company_id}`);

          if (Array.isArray(response.data) && response.data.length > 0) {
            const formattedData = response.data.map((item) => ({
              value: item.emp_id, // Assuming employee id is stored in 'emp_id'
              label: item.emp_name, // Assuming employee name is stored in 'emp_name'
            }));
            setselectedprojectmanager(formattedData);
            console.log(selectedprojectmanager[0].label);
          } else {
            console.log("No data received or empty array");
          }
        }
        if (updateValue.departments != null) {
          console.log(`Fetching departments with IDs: ${updateValue.departments}`);
          const response = await api.get(`empSiteManDetails.php?departments=${updateValue.departments}&company_id=${company_id}`);

          if (Array.isArray(response.data) && response.data.length > 0) {
            const formattedData = response.data.map((item) => ({
              value: item.d_id, // Assuming department id is stored in 'd_id'
              label: item.dept_name, // Assuming department name is stored in 'dept_name'
            }));
            setselecteddepartment(formattedData);
          } else {
            console.log("No data received or empty array");
          }
        }
        console.log(selecteddepartment);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    runFetchDepartDataTwice();
  }, [updateValue.site_manager, updateValue.project_manager_id, updateValue.departments]); // Correctly listing all dependencies in a single array


  const [members, setmembers] = useState();
  const [projectmanager, setprojectmanager] = useState();
  const [department, setdepartment] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        if (!company_id) {
          throw new Error('Missing company_id in cookies');
        }
        const response = await api.get(`empGMdetails.php?company_id=${company_id}`);
        const response2 = await api.get(`empGMdetails.php?p_m=1&company_id=${company_id}`);
        const response3 = await api.get(`department.php?company_id=${company_id}`);

        // Extract only two variables and format them
        const formattedData = response.data.map(item => ({
          value: item.emp_id, // Assuming employee id is stored in 'id'
          label: item.emp_name 
        })); // Take only the first two records

        // Extract only two variables and format them
        const formattedData2 = response2.data.map(item => ({
          value: item.emp_id, // Assuming employee id is stored in 'id'
          label: item.emp_name  // Assuming employee name is stored in 'name'
        })); // Take only the first two records

        // Extract only two variables and format them
        const formattedData3 = response3.data.map(item => ({
          value: item.d_id, // Assuming employee id is stored in 'id'
          label: item.dept_name // Assuming employee name is stored in 'name'
        })); // Take only the first two records

        setmembers(formattedData);
        setprojectmanager(formattedData2);
        setdepartment(formattedData3);
        console.log(response.data);
        console.log(response3.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);


  const handleSiteManagerSelectChange = (selectedOptions) => {
    setSelectedSiteManagers(selectedOptions);
    setupdateValues((prevState) => ({
      ...prevState,
      site_manager: selectedOptions.map((option) => option.value),
    }));
    console.log(updateValue);
  };

  const handledepartmentSelectChange = (selectedOptions) => {
    setselecteddepartment(selectedOptions);
    setupdateValues(prevState => ({
      ...prevState,
      departments: selectedOptions.map(option => option.value)
    }));
    // console.log(addproject);
  };

  const [clientName, setclientName] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`clientGM.php?company_id=${company_id}`);
        setclientName(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);


  const [BOQ, setBOQ] = useState('No File Selected');
  const [BOM, setBOM] = useState('No File Selected');

  const handleBOQFileChange = (e) => {
    const file = e.target.files[0];
    setBOQ(file.name);
    setupdateValues((prevState) => ({
      ...prevState,
      BOQ: file,
    }));
  };

  const handleBOMFileChange = (e) => {
    const file = e.target.files[0];
    setBOM(file.name);
    setupdateValues((prevState) => ({
      ...prevState,
      BOM: file,
    }));
  };

  const fileInputRef = useRef(null);

  const handleAddFileClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    setupdateValues((prevState) => ({
      ...prevState,
      files: [...prevState.files, ...files],
    }));
  };

  const handleCancelFile = (index) => {
    if (typeof allfiles.files === 'string') {
      const fileArray = allfiles.files.split(',');
      const updateFile = fileArray.filter((_, i) => i !== index);
      const updatedFileString = updateFile.join(',');
      setallfiles((prevState) => ({
        ...prevState,
        files: updatedFileString,
      }));
    } else {
      console.error('allfiles.files is not a string');
    }
  };

  function getFileUrl(filename) {
    if (!filename) return "#";
    return `/aecp_updated/AECP/src/PHP/images/${filename}`;
  }

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Col className="order-xl-2 mb-5 mb-xl-0 text-center">
          <h1>Edit Project Details</h1>
        </Col>
        <Link to="/general-admin/general-management/project1">
          {" "}
          <Button className="ml-5" style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}>Back</Button>
        </Link>
        <Container className="py-4 ">
          <div
            className="p-4 rounded"
            style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff',borderRadius: '15px'}}
          >
            <Form onSubmit={handleFormSubmit}>
              <div className="row">
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-status">Client Name</label>
                    <Input
                      className="form-control-alternative"
                      id="input-status"
                      type="select"
                      name="client_id"
                      value={updateValue.client_id}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Client Name</option>
                      {clientName && clientName.map(option => (
                        <option key={option.client_id} value={option.client_id}>{option.client_name}</option>
                      ))}
                      {!clientName || clientName.length === 0 && (
                        <option value="">No clients available</option>
                      )}

                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-name">
                      Project Name
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-name"
                      type="text"
                      name="p_name"
                      value={updateValue.p_name}
                      onChange={handleInputChange}
                      placeholder="Project Name"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="input-status"
                    >
                      Project Status
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-status"
                      type="select"
                      name="p_status"
                      onChange={handleInputChange}
                      value={updateValue.p_status}
                    >
                      {/* <option value="">Select Status</option> */}
                      <option value="to-do"  >Todo</option>
                      <option value="inprogress" >In-progress</option>
                      <option value="completed" >Completed</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-name">
                      Project Budget
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-budget"
                      type="number"
                      name="p_budget"
                      defaultValue={updateValue.p_budget}
                      onChange={handleInputChange}
                      placeholder="Project Budget"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-status">
                      Select {roleNames.projectManager}
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-status"
                      type="select"
                      name="project_manager_id"
                      value={updateValue.project_manager_id}
                      onChange={handleInputChange}
                    // required
                    >
                      <option value="">Select {roleNames.projectManager}</option>
                      {projectmanager && projectmanager.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                      {!projectmanager || projectmanager.length === 0 && (
                        <option value="">No {roleNames.projectManager}s available</option>
                      )}


                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="input-site-manager"
                    >
                      Select {roleNames.siteManager}
                    </label>
                    <Select
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isMulti
                      defaultValue={selectedSiteManagers}
                      onChange={handleSiteManagerSelectChange}
                      options={members}
                      value={selectedSiteManagers}
                    />
                  </FormGroup>
                </Col>


                <div className="col-md-6">
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-age">
                      Project Starting Date
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-age"
                      type="date"
                      name="start_date"
                      defaultValue={updateValue.start_date}
                      onChange={handleInputChange}
                      placeholder="Starting Date"
                    />
                  </FormGroup>
                </div>
                <Col md={6}>
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="input-ending"
                    >
                      Project Ending Date
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-ending"
                      type="date"
                      name="end_date"
                      defaultValue={updateValue.end_date}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="input-location"
                    >
                      Location
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-location"
                      type="location"
                      name="p_location"
                      defaultValue={updateValue.p_location}
                      onChange={handleInputChange}
                      placeholder="Location"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-site-manager">Select Department's</label>
                    <Select
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isMulti
                      value={selecteddepartment}
                      onChange={handledepartmentSelectChange}
                      options={department}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-file">
                      Upload BOQ File
                    </label>
                    <div className="custom-file-input-wrapper">
                      <label style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} className="btn btn-success p-1 custom-file-input-label" htmlFor="input-BOQ-file">
                        Choose File
                      </label>
                      <Input
                        type="file"
                        id="input-BOQ-file"
                        name="BOQ"
                        style={{ display: 'none' }}
                        onChange={handleBOQFileChange}
                      />
                      <h5>Old file: <a href={getFileUrl(allfiles.BOQ)} download>{allfiles.BOQ}</a></h5>
                      <h5>Selected file : {BOQ}</h5>
                    </div>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-file">
                      Upload BOM File
                    </label>
                    <div className="custom-file-input-wrapper">
                      <label style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} className="btn btn-success p-1 custom-file-input-label" htmlFor="input-BOM-file">
                        Choose File
                      </label>
                      <Input
                        type="file"
                        id="input-BOM-file"
                        name="BOM"
                        style={{ display: 'none' }}
                        onChange={handleBOMFileChange}
                      />
                      <h5>Old file: <a href={getFileUrl(allfiles.BOM)} download>{allfiles.BOM}</a></h5>
                      <h5>Selected file : {BOM}</h5>
                    </div>
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <label>Files:</label>
                    <div>
                      <Button
                        type="button"
                        style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black', padding: '3px'}}
                        onClick={handleAddFileClick}
                        className="p-1"
                      >
                        Upload Documents
                      </Button>
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                        multiple
                      />
                      <div className="d-flex row mt-1">
                        <div className="col">Old Files :
                          {allfiles.files.split(',').map((file, index) => (
                            <h5 key={index}>File {++index} : <a href={getFileUrl(file)} download>{file}</a><i onClick={() => handleCancelFile(index)} className="fa fa-times-circle ml-1"></i></h5>
                          ))}
                        </div>
                        <div className="col">Selected Files :
                          {updateValue.files.length > 0 ? (
                            updateValue.files.map((file, index) => (
                              <h5 className="mt-1 mt-0" key={index}>File {index + 1} : {file.name}</h5>
                            ))
                          ) : (
                            <h5>No Documents Selected</h5>
                          )}
                        </div>
                      </div>

                    </div>
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="input-description"
                    >
                      Project Description
                    </label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={updateValue.p_description}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setupdateValues((prevState) => ({
                          ...prevState,
                          p_description: data,
                        }));
                      }}
                    />
                  </FormGroup>
                </Col>
              </div>
              {/* <Link to="/admin/project"> */}
              <div className="row">
                <div className="col-md-12 text-center">
                  {" "}
                  {/* Centered button */}
                  <Button type="submit" style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}>
                    Submit
                  </Button>
                </div>
              </div>
              {/* </Link> */}
            </Form>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Editproject1;